<template>
  <BaseButton
    text
    color="white"
    retain-focus-on-click
    :ripple="false"
    :disabled="isDisabled"
    @click="openEditAnnotationPopup()"
  >
    <BaseSpriteIcon icon-name="ico-edit-line"></BaseSpriteIcon>
    <span class="context-menu-text-item">{{ $t('Context.short.edit') }}</span>
  </BaseButton>
</template>

<script>
import BaseSpriteIcon from '@/components/base/BaseSpriteIcon/BaseSpriteIcon.vue';
import BaseButton from '@/components/base/BaseButton/BaseButton';

import PopupNamesEnum from '@/enums/PopupNamesEnum';

import ContextMenuParamsFactory from '@/classes/factories/Materials/ContextMenuParamsFactory';

export default {
  name: 'EditAnnotationControl',
  components: {
    BaseSpriteIcon,
    BaseButton
  },
  computed: {
    bookId() {
      const openParams = this.$store.getters[
        'OpenParameterStore/getPublicationOpenParameters'
      ];
      return openParams?.publicationId;
    },
    isDisabled() {
      return this.$attrs.hasOwnProperty('disabled')
        ? this.$attrs.disabled
        : false;
    }
  },
  methods: {
    selectedLocator() {
      return this.$store.getters['MaterialsStore/getSelectedLocator'];
    },
    getAnnotationFullSelectedByLocator() {
      return this.$store.getters[
        'AnnotationsStore/getAnnotationFullSelectedByLocator'
      ](this.selectedLocator(), this.bookId);
    },
    openEditAnnotationPopup() {
      this.$store.dispatch('PlaybackStore/pause');
      const menuPosition = ContextMenuParamsFactory.createMenuPosition();
      const annotation = this.getAnnotationFullSelectedByLocator();
      this.$store.dispatch('ManagePopupStore/openPopup', {
        name: PopupNamesEnum.CREATE_ANNOTATION_POPUP,
        popupContext: {
          annotation,
          menuPosition
        }
      });
    }
  }
};
</script>
